const transverseHTMLTillRoot = (html, node, root) => {
  while (node !== root) {
    // if node type is of text then go to parent
    if (node.nodeType === 3) {
      node = node.parentNode;
      continue;
    }

    // Clone node
    var clone = node.cloneNode(false);
    clone.innerHTML = html;
    html = clone.outerHTML;

    node = node.parentNode;
  }
  return html;
};

export const getSelectionHTMLUntil = (document, root) => {
  var range;

  if (document.selection && document.selection.createRange) {
    range = document.selection.createRange();
    const text = range.htmlText;
    return text;
  } else if (document.getSelection) {
    var selection = document.getSelection();

    if (selection.rangeCount > 0) {
      range = selection.getRangeAt(0);
      var clonedSelection = range.cloneContents();
      const div = document.createElement("div");
      div.appendChild(clonedSelection);
      const text = div.innerHTML;
      return transverseHTMLTillRoot(text, range.commonAncestorContainer, root);
    } else {
      return "";
    }
  } else {
    return "";
  }
};
